import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { TypeAnimation } from "react-type-animation";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div
        className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full
                px-4 md:flex-row"
      >
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
            {" "}
            I'm Joyesh Kakkar
          </h2>
          <p className="text-2xl sm:text-3xl font-normal text-gray-300 pt-5">
            <TypeAnimation
              sequence={[
                "Engineering Manager",
                1000,
                "Tech Lead",
                1000,
                "Software Developer",
                1000,
              ]}
              wrapppers="div"
              repeat={Infinity}
              cursor={false}
              speed={20}
              style={{
                paddingLeft: "5px",
              }}
            />
          </p>
          <p className="text-gray-500 py-4 sm:text-xl">
            I have 12 years of professional software development experience
            architecting and creating scalable and reliable globally used web
            applications.
          </p>

          <div>
            <Link
              to="skills"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center 
                    rounded-md bg-gradient-to-r first-letter from-cyan-500 to-blue-500 cursor-pointer"
            >
              See More
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>

        <div>
          {/* <img src={HeroImage} alt='my profile' className='rounded-2xl mx-auto w-2/3 md:w-full' /> */}
        </div>
      </div>
    </div>
  );
};

export default Home;
